import Peers from './Peers';

export default Peers;
